import { useEffect, useState } from 'react';

interface ShippingSettings {
  label: string;
  isFree: boolean;
  threshold: number;
  loading: boolean;
}

export function useShippingInfo(orderAmountCents: number): ShippingSettings {
  const [threshold, setThreshold] = useState(0);
  const [aboveLabel, setAboveLabel] = useState('免運費');
  const [belowLabel, setBelowLabel] = useState('順豐到付');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${window.location.origin}/api/public/settings`)
      .then((res) => res.json())
      .then((json) => {
        const data = json.data ?? json;
        const thresholdHkd = Math.max(0, Number(data.free_shipping_threshold ?? 0));
        setThreshold(Number.isFinite(thresholdHkd) ? thresholdHkd * 100 : 0);
        setAboveLabel(String(data.shipping_above_threshold_label || '免運費'));
        setBelowLabel(String(data.shipping_below_threshold_label || '順豐到付'));
      })
      .catch(() => {
        // keep defaults
      })
      .finally(() => setLoading(false));
  }, []);

  const isFree = !loading && (threshold <= 0 || orderAmountCents >= threshold);
  return {
    label: isFree ? aboveLabel : belowLabel,
    isFree,
    threshold,
    loading,
  };
}
